
export const SAVE_STORECODE = 'SAVE_STORECODE'
export const GET_STORECODE = 'GET_STORECODE'
export const SAVE_MEMBERCODE = 'SAVE_MEMBERCODE'
export const GET_MEMBERCODE = 'GET_MEMBERCODE'
export const SAVE_OPENID = 'SAVE_OPENID'
export const GET_OPENID = 'GET_OPENID'
export const SAVE_EMPLOYEECODE = 'SAVE_EMPLOYEECODE'
export const GET_EMPLOYEECODE = 'GET_EMPLOYEECODE'
export const SAVE_POSITION = 'SAVE_POSITION'
export const GET_POSITION = 'GET_POSITION'
export const SAVE_TOKEN = 'SAVE_TOKEN'
export const GET_TOKEN = 'GET_TOKEN'
export const SAVE_USERNAME = 'SAVE_USERNAME'
export const SAVE_USERFROMTYPE = 'SAVE_USERFROMTYPE'
export const SET_BOOKINGNUM = 'SET_BOOKINGNUM'
export const SET_COMMENNUM = 'SET_COMMENNUM'
export const SAVE_NICKNAME = 'SAVE_NICKNAME'
export const SAVE_MOBILE = 'SAVE_MOBILE'
export const GET_NICKNAME = 'GET_NICKNAME'
export const GET_MOBILE = 'GET_MOBILE'
export const SAVE_UNIONID = 'SAVE_UNIONID'
export const GET_UNIONID = 'GET_UNIONID'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js